import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { EstatusService } from 'app/main/wizard-cgo/services/statusEncuesta.service';

@Component({
  selector: 'app-modal-confirmacion',
  templateUrl: './modal-confirmacion.component.html',
  styleUrls: ['./modal-confirmacion.component.scss']
})
export class ModalConfirmacionComponent implements OnInit {

  nombresColumnas: string[] = ['clave', 'valor'];
  infoTabla: any = [
    { clave: 'company_name' },
    { clave: 'short_name' },
    { clave: 'publication_name' },
    { clave: 'company', logo: true },
    { clave: 'certificate', logo: true },
    { clave: 'foundation_year' },
    { clave: 'fullTime_employees' },
    { clave: 'parcial_employees' },
    { clave: 'total_employees' },
    { clave: 'sector' },
    { clave: 'sub_sector' },
    { clave: 'rankig_type' },
    { clave: 'ranking_name' },
    { clave: 'name_RH' },
    { clave: 'email_RH' },
    { clave: 'tel_RH' },
    { clave: 'ext_RH' },
    { clave: 'cel_RH' },
    { clave: 'state' },
    { clave: 'multinational_group' },
    { clave: 'country_application' },
  ];
  tablaOk: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<ModalConfirmacionComponent>,
    private dialog: MatDialog,
    private translateSrv: TranslateService,
    private statusEncuesta: EstatusService
  ) { }

  ngOnInit(): void {
    console.log("datos modal:",this.datos);

    this.llenaTabla();
  }

  llenaTabla(){
    this.infoTabla.forEach(campo => {
      let valor: any;
      if(campo.logo == undefined){
        valor = this.datos.datosConfirmacion.company[campo.clave] != undefined ? this.datos.datosConfirmacion.company[campo.clave] : "";
      } else{
        valor = this.datos.datosConfirmacion.logos[campo.clave].image;
      }
      campo.valor = valor;
      console.log("valor:",valor);

    });
    console.log("infoTabla:",this.infoTabla);

    this.tablaOk = true;
  }

  salir(){
    this.dialogRef.close();
  }

  activarEncuesta(){
    let mensajeTexto1 = this.translateSrv.instant('CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE1');
    let mensajeTexto2 = this.translateSrv.instant('CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE2');
    let confirmarEmpresa = this.translateSrv.instant('CONFIRMACION.BOTONES-MODALES.ELIMINAR.VALIDAR');
    let salir = this.translateSrv.instant('CONFIRMACION.BOTONES-MODALES.ELIMINAR.SALIR');
    let errorNombreEmpresa = this.translateSrv.instant('CONFIRMACION.BOTONES-MODALES.ELIMINAR.ERRORNOMBREEMPRESA');
    let cerrar = this.translateSrv.instant('CONFIRMACION.BOTONES-MODALES.ELIMINAR.CERRAR');
    let codigo = Math.random().toString(36).substring(7);
    Swal.fire({
      title: mensajeTexto1+'<font color="red">'+codigo+'</font>'+mensajeTexto2,
      icon: 'info',
      input:'text',
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: salir,
      confirmButtonText: confirmarEmpresa
    })
    .then( (borrar) => {
      console.log(borrar);
      if (borrar.value == codigo) {
        if (this.datos.institutoId=="1") {
          this.postConfirmData(1);
        }else{
          console.log("si jalo con otro instituto");
          this.actualizaEstatusEncuestaAbierta();
        }
      }
      else{
        if(!borrar.dismiss){
          Swal.fire({
            icon: 'error',
            title: errorNombreEmpresa,
            showConfirmButton: true,
            confirmButtonText: cerrar
          });
        }
      }
    });
  }

  async actualizaEstatusEncuestaAbierta(){
    let success = this.translateSrv.instant('CONFIRMACION.BOTONES-MODALES.ELIMINAR.SUCCES');
    let estatus = 3;
    let datos = {
      open: 1,
      accionText: 'ActivaEstatEncu',
      userAdministrator: this.datos.nameUserAdmin,
    }
    console.log("datos Open: ",datos);

    const resultado: any = await this.statusEncuesta.activarEstatusSurvey(datos).toPromise().then((res:any) => {return res});
    console.log("actualizaEstatusEncuestaAbierta:",resultado);
    let datConfirm = {
      project_manager_confirm_data: 0,
    }
    const postConfirm: any = await this.statusEncuesta.postConfirmData(this.datos.idProducto,datConfirm).toPromise().then((res:any) => {return res});

    this.dialogRef.close({
      procesoCompleto: true,
      resultado,
      success,
      estatus
    });
  }

  async postConfirmData(status:number){
    let datos = {
      project_manager_confirm_data: status,
    }
    console.log("datos Open: ",datos);

    const resultado: any = await this.statusEncuesta.postConfirmData(this.datos.idProducto,datos).toPromise().then((res:any) => {return res});
    console.log("actualizaEstatusEncuestaAbierta:",resultado);
      this.dialogRef.close({
        procesoCompleto: true,
      });
  }

}
